__turbopack_context__.v({
  "collapsed": "CollapsibleContent-module-scss-module__mkVtcG__collapsed",
  "collapsing": "CollapsibleContent-module-scss-module__mkVtcG__collapsing",
  "expanded": "CollapsibleContent-module-scss-module__mkVtcG__expanded",
  "expanding": "CollapsibleContent-module-scss-module__mkVtcG__expanding",
  "fade": "CollapsibleContent-module-scss-module__mkVtcG__fade",
  "fast": "CollapsibleContent-module-scss-module__mkVtcG__fast",
  "instant": "CollapsibleContent-module-scss-module__mkVtcG__instant",
});
